<template>
  <div>
    <Header />
    <div class="get-started">
      <div class="banner-main">
        <div class="banner-content">
          <div class="container py-5">
            <br /><br /><br /><br /><br /><br /><br />
            <div class="col text-center my-4">
              <h1>
                <b>Web Capture Service in a legally admissible way</b>
                <br />
              </h1>
              <br />
              <h5 class="text-muted">
                Get evidence from the internet with digital signature in 3 steps
              </h5>
              <button class="btn my-5" @click="getStartedHandler()">
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper container-xl pb-5 mb-5 rounded">
        <ul class="StepProgress">
<!--           <li id="1" class="StepProgress-item" v-bind:class="{ current: currentStep === 1, isDone: currentStep > 1 }">
            <strong>Choose evidence type</strong>
            <div class="col content-container">
              <transition>
                <keep-alive>
                  <TypeSelection v-if="currentStep === 1" :nextHandler="nextHandler"
                    :typeSelectionCB="typeSelectionCB" />
                </keep-alive>
              </transition>
            </div>
            <div class="col short-content-container text-muted">
              <span v-if="evType == 1"> Selected web capture</span>
              <span v-else> Selected local document signing</span>
            </div>
          </li> -->
          <li id="2" class="StepProgress-item" v-bind:class="{ current: currentStep === 2, isDone: currentStep > 2 }">
            <strong>Select content</strong>
            <div class="col content-container">
              <transition>
                <keep-alive>
                  <WebCaptureSelection v-if="currentStep === 2 && evType === 1" :nextHandler="nextHandler"
                    :webCapSelectionCB="webCapSelectionCB" />
                  <FileSelector v-if="currentStep === 2 && evType === 2" :nextHandler="nextHandler"
                    :fileSelectorCB="fileSelectorCB" />
                </keep-alive>
              </transition>
            </div>
            <div class="col short-content-container text-muted">
              <span v-if="evType == 1"> {{ captureURL }}</span>
              <span v-else> Selected local document signing</span>
            </div>
          </li>
          <li id="3" class="StepProgress-item" v-bind:class="{ current: currentStep === 3, isDone: currentStep > 3 }">
            <strong>Preview</strong>
            <div class="col content-container">
              <transition>
                <keep-alive>
                  <WebCapture v-if="currentStep === 3 && evType === 1" :captureURL="captureURL"
                    :recaptchaResponse="recaptchaResponse" :nextHandler="nextHandler" :webCapCB="webCapCB" />
                  <SignFile v-if="currentStep === 3 && evType === 2" :nextHandler="nextHandler"
                    :selectedFile="selectedFile" :signFileCB="signFileCB" />
                </keep-alive>
              </transition>
            </div>
            <div class="col short-content-container text-muted">
              <span> Preview verified by user</span>
            </div>
          </li>
          <li id="4" class="StepProgress-item" v-bind:class="{ current: currentStep === 4, isDone: currentStep > 4 }">
            <strong ref="paymentdiv">Payment</strong>
            <div class="col content-container">
              <transition>
                <Payment v-if="currentStep === 4" :nextHandler="nextHandler" :OTUItems="OTUItems" />
              </transition>
            </div>
            <div class="col short-content-container text-muted">
              <span> Payment Complete</span>
            </div>
          </li>
          <li id="5" class="StepProgress-item" v-bind:class="{ current: currentStep === 5, isDone: currentStep > 5 }">
            <strong>Finish</strong>
            <div class="col content-container">
              <transition>
                <Finish v-if="currentStep === 5" :OTUItems="OTUItems" />
              </transition>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import WebCapture from "./WebCapture.vue"
import Summary from "./Summary.vue"
import Payment from "./Payment.vue"
import TypeSelection from "./TypeSelection.vue"
import WebCaptureSelection from "./WebCaptureSelection.vue"
import Finish from "./Finish.vue"
import FileSelector from "./FileSelector"
import SignFile from "./SignFile.vue"
import timeout from "../functions/timeout"
import Footer from "./Footer"
import Header from "./Header"
export default {
  name: "GetStarted",
  data() {
    return {
      currentStep: 1,
      evType: null,
      captureURL: null,
      recaptchaResponse: "",
      webCapData: null,
      summaryItems: [],
      OTUItems: [],
      selectedFile: null,
    }
  },
  mounted() {
    // Show only webcapture for now
    this.evType = 1
    this.currentStep=2
    var now = new Date().getTime()
    var backupTime = localStorage.getItem('backup_time')
    if (backupTime && (now - backupTime) < 1.7 * 60 * 60 * 1000) {
      let backup = localStorage.getItem("OTUbackup")
      if (backup) {
        this.OTUItems = JSON.parse(backup)
        this.currentStep = 4
        this.evType = this.OTUItems[0].evType
        const el = this.$refs.paymentdiv
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 1000)
      }
    }
  },
  methods: {
    async getStartedHandler() {
      this.currentStep = 2
      this.scrollToContet(2)
    },
    async nextHandler(id) {
      if (id < 6) {
        this.currentStep = id + 1
        this.scrollToContet(id)
      }
    },
    scrollToContet(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      })
    },
    typeSelectionCB(data) {
      this.evType = data
    },
    webCapSelectionCB(data) {
      this.captureURL = data.url
      this.recaptchaResponse = data.captchaResponse
    },
    fileSelectorCB(data) {
      this.selectedFile = data
    },
    signFileCB(data) {
      data.map((item, index) => {
        this.summaryItems = []
        this.summaryItems.push({
          filename: item.filename,
          type: "Local file",
          timestamp: item.timestamp,
        })
        this.OTUItems = []
        this.OTUItems.push({
          id: item.signatureID,
          evType: 2,
          filename: item.filename,
          type: "Local file",
          timestamp: item.timestamp,
        })
      })
    },
    webCapCB(data) {
      this.webCapData = data
      data.map((item, index) => {
        this.summaryItems.push({
          filename: item.metadata.Domain,
          type: "Web Archive",
          timestamp: item.metadata.Timestamp,
        })
        this.OTUItems = []
        this.OTUItems.push({
          id: item.captureID,
          evType: 1,
          filename: item.metadata.Domain,
          type: "Web Archive",
          timestamp: item.metadata.Timestamp,
        })
      })
    },
  },
  components: {
    WebCapture,
    Summary,
    Payment,
    TypeSelection,
    WebCaptureSelection,
    Finish,
    FileSelector,
    SignFile,
    Header,
    Footer,
  },
}
</script>
<style scoped>
.get-started {
  background: var(--background-primary);
}

.banner-main {
  height: 100%x;
  background-color: var(--background-primary);
  background-image: url("../assets/images/background.jpg");
  backdrop-filter: blur(10px);
  background-position: -2px 0;
  color: #eee;
  background-repeat: no-repeat;
  background-size: cover;
}

.banner-content {
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.862);
}

.banner-main .text-muted {
  color: #b9b9b9 !important;
}

.banner-main h1 {
  font-size: 2.5rem;
}

.banner-main button {
  background-color: #00c781;
  color: #fff;
  font-weight: 500;
}

.wrapper {
  margin-top: 70px;
  background-color: var(--background-secondary);
  font-size: 14px;
  padding-top: 70px;
  padding-right: 80px;
  color: var(--font-color-primary);
  box-shadow: 0 12px 11px rgba(0, 0, 0, 0.035), 0 100px 80px rgba(0, 0, 0, 0.07);
  margin-bottom: 70px;
}

.StepProgress {
  position: relative;
  padding-left: 75px;
  list-style: none;
}

.StepProgress::before {
  display: inline-block;
  content: "";
  position: absolute;
  top: 0;
  left: 41px;
  width: 10px;
  height: 100%;
  border-left: 5px solid var(--border-color);
}

.StepProgress-item {
  position: relative;
  counter-increment: list;
}

.StepProgress-item:not(:last-child) {
  padding-bottom: 40px;
}

.StepProgress-item::before {
  display: inline-block;
  content: "";
  position: absolute;
  left: -34px;
  height: 100%;
  width: 10px;
}

.StepProgress-item::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: -48px;
  width: 32px;
  height: 32px;
  border: 10px solid var(--border-color);
  border-radius: 50%;
  background-color: var(--background-primary);
}

.StepProgress-item.isDone::before {
  border-left: 5px solid #00c781;
}

.StepProgress-item.isDone::after {
  content: "✔";
  font-size: 16px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  border: 2px solid #00c781;
  background-color: #00c781;
}

.StepProgress-item.current::before {
  border-left: 5px solid var(--primary-orange-yellow);
}

.StepProgress-item:last-child.current::before {
  border-left: 5px solid #ffffff;
}

.StepProgress-item:last-child.current::after {
  border: 10px solid #00c781;

}

.StepProgress-item.current::after {
  content: "";
  padding-top: 1px;
  left: -48px;
  width: 32px;
  height: 32px;
  top: -4px;
  font-size: 24px;
  text-align: center;
  border: 10px solid var(--primary-orange-yellow);
}

.StepProgress strong {
  color: rgb(194, 194, 194);
  display: block;
  font-size: 16px;
  padding-left: 40px;
}

.StepProgress-item.current strong,
.StepProgress-item.isDone strong {
  color: var(--font-color-secondary);
  display: block;
  font-size: 20px;
}

.content-container {
  padding: 15px 10px 15px 40px;
  display: none;
  min-height: 600px;
}

.StepProgress-item.current .content-container {
  display: inherit;
}

.StepProgress-item:last-child.isDone .content-container {
  display: inherit;
}

.selection-btn {
  color: rgb(92, 92, 92);
  font-weight: 400;
}

.StepProgress-item .short-content-container {
  padding: 10px 10px 10px 40px;
  font-size: small;
  display: none;
}

.StepProgress-item.isDone .short-content-container {
  display: inherit;
}

@media only screen and (max-width: 600px) {
  .wrapper {
    margin-top: 0px;
    padding-top: 70px;
    padding-right: 20px;
  }

  .StepProgress {
    padding-left: 35px;
  }

  .StepProgress::before {
    top: 0;
    left: 1px;
  }

  .StepProgress-item::after {
    top: 0;
    left: -43px;
    width: 22px;
    height: 22px;
    border: 5px solid var(--border-color);
  }

  .StepProgress-item.isDone::after {
    font-size: 10px;
    line-height: 20px;
    border: 2px solid #00c781;
  }

  .StepProgress-item.current::after {
    padding-top: 1px;
    left: -43px;
    width: 22px;
    height: 22px;
    top: -4px;
    border: 5px solid var(--primary-orange-yellow);
  }

  .StepProgress strong {
    padding-left: 0px;
  }

  .content-container {
    padding: 15px 10px 15px 0px;
  }

  .StepProgress-item .short-content-container {
    padding: 10px 10px 10px 0px;
  }
}
</style>
<style>
.back-btn {
  background-color: #c2c2c2;
  font-weight: bold;
  font-size: 13px;
  color: #555;
  max-width: 27vw;
}

.btn-outline-primary {
  border-color: #10a2e6;
  color: #10a2e6;
}

.btn-outline-primary:hover {
  border-color: #10a2e6;
  background-color: #10a2e6;
}

.next-btn {
  background: var(--primary-green);
  color: white;
  font-weight: bold;
  font-size: 13px;
  max-width: 27vw;
}

.next-btn:hover {
  filter: brightness(110%) saturate(110%);
  color: white;
  background: var(--primary-green);
}

.next-btn:disabled:hover {
  background: var(--primary-green);
}

.text-blue {
  color: #10a2e6;
}

.alert-info {
  color: #fff;
  border: 1px solid #10a2e6;
  background-color: #10a2e6;
  padding: 8px 10px;
  border-radius: 5px;
  font-weight: 500;
}

.danger-info {
  color: #fff;
  border: 1px solid #eb4e4e;
  background-color: #f14c4c;
  padding: 8px 10px;
  border-radius: 5px;
  font-weight: 500;
}

.success-info {
  color: #fff;
  border: 1px solid #00c781;
  background-color: #00c781;
  padding: 8px 10px;
  border-radius: 5px;
  font-weight: 500;
}

.v-enter-active {
  animation: bounceIn 0.5s;
}

.v-leave {
  animation: bounceIn 1s reverse;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: translateX(-10%);
  }

  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes glow {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GetStarted.vue